import { assignInput, BaseModel } from '../base.model';
import { FileDataModel } from '../sparta-api/fileData-model';

export class BackgroundModel extends BaseModel {
  isNewItem: boolean;
  editing: boolean;
  showFiles: boolean;
  Delete: boolean = false;

  HRRef: string = '';
  Type: string = '';
  CertDate: Date;
  ExpireDate: Date;
  Score: string = '';
  Result: string = '';
  bActive: boolean = true;
  editable: boolean = false;

  Files: FileDataModel[] = [];

  KeyID?: number;
  SkillTester?: any;
  Notes?: string;

  constructor(o: any = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
